import { render, staticRenderFns } from "./auctions.vue?vue&type=template&id=852915dc"
import script from "./auctions.vue?vue&type=script&lang=js"
export * from "./auctions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports